"use strict";

exports.__esModule = true;
exports.ReportList = ReportList;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _System = require("../../../System");
var _Theme = require("../../Theme");
var _ReportThumbnail = require("../ReportThumbnail");
var _Auth = require("../../Auth");
var _Core = require("../../Core");
var _excluded = ["onItemClick", "items", "selectedIds", "compact"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ReportListContainer = _styledComponents["default"].div.withConfig({
  displayName: "ReportList__ReportListContainer",
  componentId: "sc-lplrss-0"
})(["display:flex;flex:1;flex-direction:column;height:100%;padding:1rem;"]);
var ReportListItem = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "ReportList__ReportListItem",
  componentId: "sc-lplrss-1"
})(["color:", ";background:", ";border:solid 1px ", ";border-bottom:solid 1px ", ";padding:0.5rem;display:flex;flex-shrink:0;&:hover{text-decoration:none;color:", ";background:", ";border:solid 1px ", ";}"], (0, _Theme.selectable)("ThumbnailListItemColor"), (0, _Theme.selectable)("ThumbnailListItemBackground"), function (props) {
  return props["aria-selected"] ? props.theme.SelectedThumbnailListItemBorderColor : "transparent";
}, (0, _Theme.selectable)("ThumbnailListItemBorderColor"), (0, _Theme.val)("SelectedThumbnailListItemColor"), (0, _Theme.val)("SelectedThumbnailListItemBackground"), (0, _Theme.val)("SelectedThumbnailListItemBorderColor"));
var ReportListItemThumbnail = (0, _styledComponents["default"])(_ReportThumbnail.ReportThumbnail).withConfig({
  displayName: "ReportList__ReportListItemThumbnail",
  componentId: "sc-lplrss-2"
})(["border:solid 1px ", ";"], (0, _Theme.selectable)("ThumbnailListItemBorderColor"));
var ReportListItemBody = _styledComponents["default"].div.withConfig({
  displayName: "ReportList__ReportListItemBody",
  componentId: "sc-lplrss-3"
})(["flex:1;display:flex;"]);
var ReportListItemLabel = _styledComponents["default"].div.withConfig({
  displayName: "ReportList__ReportListItemLabel",
  componentId: "sc-lplrss-4"
})(["color:", ";line-height:1;margin-left:1rem;font-size:", ";font-weight:", ";"], (0, _Theme.selectable)("ThumbnailListItemColor"), function (props) {
  return props.theme.fontSizeLarge;
}, (0, _Theme.val)("fontWeightHeavy"));
var ReportListItemDescription = _styledComponents["default"].p.withConfig({
  displayName: "ReportList__ReportListItemDescription",
  componentId: "sc-lplrss-5"
})(["color:", ";margin-left:1rem;"], (0, _Theme.selectable)("ThumbnailListItemColor"));

/**
 * Shows a list of reports.
 */
function ReportList(_ref) {
  var onItemClick = _ref.onItemClick,
    items = _ref.items,
    _ref$selectedIds = _ref.selectedIds,
    selectedIds = _ref$selectedIds === void 0 ? [] : _ref$selectedIds,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var thumbnailSize = compact ? 20 : 64;
  var rowStyle = {
    padding: compact ? "0" : "10px 0",
    flexDirection: compact ? "row" : "column",
    justifyContent: compact ? "space-between" : "flex-start"
  };
  function renderReportListRow(item) {
    return /*#__PURE__*/_react["default"].createElement(ReportListItem, {
      key: item.id,
      "data-testid": "ReportListItem",
      to: (0, _System.getScreenURL)("Report", item),
      "aria-selected": selectedIds.includes(item.id),
      onClick: typeof onItemClick !== "function" ? undefined : function (e) {
        e.preventDefault();
        onItemClick(item);
      }
    }, /*#__PURE__*/_react["default"].createElement(ReportListItemThumbnail, {
      width: thumbnailSize,
      height: thumbnailSize,
      report: item
    }), /*#__PURE__*/_react["default"].createElement(ReportListItemBody, {
      style: rowStyle
    }, /*#__PURE__*/_react["default"].createElement(ReportListItemLabel, {
      "data-testid": "ReportListItem.label",
      style: {
        flex: compact ? "0.5" : "none"
      }
    }, item.name), /*#__PURE__*/_react["default"].createElement(ReportListItemDescription, {
      style: {
        flex: compact ? "1" : "none"
      }
    }, item.element.props.description)));
  }
  function renderExternalRow(item) {
    var Thumbnail = item.thumbnail;
    return /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
      key: item.id,
      permission: item.permission
    }, /*#__PURE__*/_react["default"].createElement(ReportListItem, {
      key: item.id,
      "data-testid": "ReportListItem",
      to: item.path
    }, /*#__PURE__*/_react["default"].createElement(Thumbnail, {
      width: thumbnailSize,
      height: thumbnailSize
    }), /*#__PURE__*/_react["default"].createElement(ReportListItemBody, {
      style: rowStyle
    }, /*#__PURE__*/_react["default"].createElement(ReportListItemLabel, {
      "data-testid": "ReportListItem.label",
      style: {
        flex: compact ? "0.5" : "none"
      }
    }, item.name), /*#__PURE__*/_react["default"].createElement(ReportListItemDescription, {
      style: {
        flex: compact ? "1" : "none"
      }
    }, item.description))));
  }
  return /*#__PURE__*/_react["default"].createElement(ReportListContainer, _extends({
    "data-testid": "ReportList"
  }, extra), items.map(function (item) {
    // $FlowFixMe
    if (item.path) {
      // flow can't handle multiple ORs
      return /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, {
        key: "external" + item.name
      }, renderExternalRow(item));
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, {
      key: item.name
    }, renderReportListRow(item));
  }));
}